export const PRODUCT_TEMPLATES = {
  /**
   * Over the counter
   * No prescription
   */
  OTC: 'OTC',

  /**
   * Over the counter extended, products that were reclasified from Rx and can be sold without prescription but it requires doctor/pharmacist consultation/recomandation
   * Optional prescription
   */
  OTX: 'OTx',

  /**
   * Mandatory prescription
   */
  RX: 'Rx',
} as const

export type PRODUCT_TEMPLATES =
  (typeof PRODUCT_TEMPLATES)[keyof typeof PRODUCT_TEMPLATES]
